import { useCallback, useMemo, useState } from "react";
import BaseModel from "base/BaseModel";
import ToastMsg from "components/Toast/index";
import { commonAxiosPostRequest } from "base/Request";
import { TokenLocalStorageKey, WebSiteConfig } from "base/Constant";

const useUserHook = (savedModelInstance = {}) => {
	const [token, setToken] = useState(savedModelInstance?.token);
	const [userData, setUserData] = useState(savedModelInstance?.userData);
	const [state, setState] = useState(savedModelInstance?.state);

	const isLoggedIn = useMemo(() => !!userData?._id, [userData?._id]);

	async function login() {
		const [error, response] = await commonAxiosPostRequest('/sso/msal/login', {
			successRedirect: `${WebSiteConfig.LoginSuccessRedirect}/permission?`
		}, { showLoading: true });
		const url = response?.url;
		if (!url) {
			ToastMsg(error?.message || 'System Error!', "error")
		}
		return url;
	}

	async function logout() {
		setToken(null);
		setUserData(null);
		window.localStorage.setItem(TokenLocalStorageKey, '');
		const post_logout_redirect_uri = `${WebSiteConfig.BaseRequestUrl}/sso/msal/logout`;
		window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURIComponent(post_logout_redirect_uri)}`;
	}

	// 获取当前登录用户信息
	async function getMe() {
		const [error, response] = await commonAxiosPostRequest('/sso/msal/me/userinfo', {}, { showLoading: true });
		console.log('[获取到登录用户信息]', response);
		setUserData(response || {});
		if (!response?.id) {
			ToastMsg(error?.message || 'System Error!', "error")
		}
		return !!response;
	}

	const onSaveInstanceState = useCallback(
		() => ({
			token,
			userData,
			state,
		}),
		[token, userData, state]
	);


	return {
		token,
		userData,
		isLoggedIn,
		onSaveInstanceState,
		state,
		setState,
		login,
		logout,
		getMe,
		setUserData,
	}
}

const UserModel = BaseModel(useUserHook, "UserModel");

export { useUserHook };
export default UserModel;
